import { render, staticRenderFns } from "./formConsultation.vue?vue&type=template&id=5cf1b1f2&scoped=true&"
import script from "./formConsultation.vue?vue&type=script&lang=js&"
export * from "./formConsultation.vue?vue&type=script&lang=js&"
import style0 from "./formConsultation.vue?vue&type=style&index=0&id=5cf1b1f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf1b1f2",
  null
  
)

export default component.exports